/**
 * 谜语猜站点配置。复制 share-kit 到其他项目时，替换这一份配置即可。
 */
import type { SharePayload, ShareSite } from '../../share-kit/types.ts'

export const miyucaiSite: ShareSite = {
  name: '谜语猜',
  slogan: '启迪智慧 妙趣横生',
  hashtags: ['谜语猜', '智力谜题'],
  notice: '微信等平台的链接卡片使用网页简介，不含谜底和战绩。分数和谜底只出现在下方文案和海报里。',
  theme: {
    bg: '#f4f6fa',
    surface: '#fbfcfe',
    text: '#2a3150',
    muted: '#6d7690',
    primary: '#2f3f86',
    accent: '#c44732',
    border: '#d3dced',
    paper: '#f7f1e6',
    fontFamily: '"Noto Sans SC", "PingFang SC", "Songti SC", sans-serif',
  },
}

export const miyucaiSitePayload: SharePayload = {
  modalTitle: '分享谜语猜',
  headline: '谜语猜',
  text: '海量谜语、脑筋急转弯和益智游戏。',
  url: 'https://miyucai.com/?from=challenge',
  footer: '欢迎来到谜语猜',
  seal: '谜',
}
